import { useRequestsHandlerData } from './useRequestsHandlerData';
import { levelModalContent, loseQuizContent } from '../constants/copyright-modals';
import { getReward } from '../utils/helpers';
import { useModal } from './useModal';
import { nyTaskContent } from '../constants/copyright';
import { useContent, useProducts } from '../redux/reducer/content';
import { useEffect, useRef } from 'react';
import { useModalsDataActions } from './useModalsDataActions';
import { prizeRewards } from '../utils/prizes/prizes';
import { useTranslation } from '../translations';

const {
  quiz: { result: resultCopy },
  successQuizModal,
} = nyTaskContent;

export const useNyTaskRequestHandler = ({ setQuizScore, setActiveItem, setButtonId, quizScore, callbacks, reset }) => {
  const {
    quizQuests: { activeQuiz },
  } = useContent();
  const { buyProducts } = useProducts();

  const { addModal, closeModal } = useModal();

  const { addModal: addModalToQueue } = useModalsDataActions();
  const { t } = useTranslation();
  const submittedRef = useRef(false);
  const handledRef = useRef(false); // защищает fulfilled (показ модалок)

  useEffect(() => {
    submittedRef.current = false;
    handledRef.current = false;
  }, [activeQuiz?.id]);

  // отправка результата — один раз
  useEffect(() => {
    if (!activeQuiz || quizScore?.length !== activeQuiz?.questions?.length) return;
    if (submittedRef.current) return;
    submittedRef.current = true;
    callbacks.submitQuizQuest({ id: activeQuiz.id, answers: quizScore });
  }, [quizScore, activeQuiz, callbacks]);

  const openWithExtraPrizes = (groupPrizes, extraModals = []) => {
    const groupRewards = groupPrizes.map((prize) => {
      const { image, title } = prize;
      const rewards = prizeRewards(prize);
      const icons = rewards.reduce((acc, { type }) => ({ ...acc, [type]: image }), {});
      return {
        type: 'wModal',
        props: { type: 'level', title, rewards, extraIcons: icons, prize, ...levelModalContent },
      };
    });

    return [...extraModals, ...groupRewards];
  };

  return useRequestsHandlerData([
    {
      address: 'requestsSubmitQuizQuest',
      fulfilled(data) {
        if (handledRef.current) return;
        handledRef.current = true;

        const { result: quizApiResult } = data;
        const { correct: truth, isWin, prize, groupPrizes } = quizApiResult;

        const status = isWin ? 'win' : 'lose';

        ({
          lose() {
            const localReset = () => {
              setQuizScore([]);
              setActiveItem(0);
              setButtonId('');
            };

            const props = {
              ...loseQuizContent,
              id: activeQuiz?.id,
              quizAnswersData: { truth, wrong: quizScore?.length - truth },
              reset: localReset,
              end: () => {
                handledRef.current = false;
                submittedRef.current = false;
                reset();
              },
            };

            openWithExtraPrizes(groupPrizes, [{ type: 'loseModal', props }]).forEach((modalData) =>
              addModalToQueue(modalData),
            );
          },
          win() {
            const { reward_bonuses, ...otherRewards } = prize ?? {};

            const { value, field } = getReward(otherRewards, t);

            const { link, title, description, promocode, terms_of_use } = prize ?? {};
            console.log('win() prize: ', prize);

            const customGoBackCallback = () => {
              addModal({
                type: 'promocodeModal',
                props: {
                  title: 'Лови промокод!',
                  promoCode: promocode,
                  text: description,
                  buttons: [
                    {
                      attr: {
                        text: 'Категория Korea Collection',
                        className: 'promocode-modal__button custom-button custom-button_yellow',
                        tag: 'a',
                        href: 'https://goldapple.ru/rozovaja-linija-for-me',
                        target: '_blank',
                      },
                    },
                    {
                      attr: {
                        text: 'Продолжить',
                        className: 'promocode-modal__button custom-button custom-button_gray',
                      },
                      action: 'close',
                    },
                  ],
                },
              });
              reset();
              handledRef.current = false;
              submittedRef.current = false;
            };

            const prizeData =
              typeof value === 'number' && field !== 'promocode'
                ? { [field]: value }
                : { promocodeData: { link, title, description, promocode, rules: terms_of_use } };

            const props = {
              ...successQuizModal,
              img: activeQuiz?.final_image,
              selectionProducts: buyProducts.filter(({ quiz_quest_id }) => quiz_quest_id === activeQuiz?.id),
              result: {
                title: resultCopy.title,
                items: { right: truth, wrong: quizScore?.length - truth },
              },
              reward_bonuses,
              ...prizeData,
              buttons: successQuizModal.buttons.map((button) => ({
                ...button,
                attr: {
                  ...button.attr,
                  customCallbacks: {
                    customGoBackCallback,
                    reset,
                  },
                  callbackKey: activeQuiz?.id === 93 ? 'customGoBackCallback' : 'reset',
                },
              })),
            };

            if (activeQuiz?.id === 93) {
              delete props.promocodeData;
            }

            addModal({ type: 'quizWinModal', props });

            /* openWithExtraPrizes(
              groupPrizes,
              [{type: "quizWinModal", props}]
            ).forEach(modalData => addModalToQueue(modalData)); */
          },
        })[status]?.();
      },
      rejected() {
        handledRef.current = false;
        submittedRef.current = false;
        reset();
        closeModal({ type: 'all' });
      },
    },
  ]);
};
